import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SavePlayerInput_InputAdapter_instance1je9qlh2ltjfd as SavePlayerInput_InputAdapter_instance } from '../type/adapter/SavePlayerInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerMutation_VariablesAdapterClass;
function SavePlayerMutation_VariablesAdapter() {
  if (SavePlayerMutation_VariablesAdapterClass === VOID) {
    class $ {
      w6h(writer, value, customScalarAdapters, withDefaultValues) {
        writer.o4a('input');
        obj(SavePlayerInput_InputAdapter_instance).u3x(writer, customScalarAdapters, value.v6h_1);
      }
    }
    initMetadataForObject($, 'SavePlayerMutation_VariablesAdapter');
    SavePlayerMutation_VariablesAdapterClass = $;
  }
  return SavePlayerMutation_VariablesAdapterClass;
}
var SavePlayerMutation_VariablesAdapter_instance;
function SavePlayerMutation_VariablesAdapter_getInstance() {
  return SavePlayerMutation_VariablesAdapter_instance;
}
//region block: init
SavePlayerMutation_VariablesAdapter_instance = new (SavePlayerMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SavePlayerMutation_VariablesAdapter_instance as SavePlayerMutation_VariablesAdapter_instance2j730pyqlhj9r,
};
//endregion

//# sourceMappingURL=SavePlayerMutation_VariablesAdapter.mjs.map
